import { ANALYTICS } from '../../constants/common';
import { trackFormInput, trackFormWorkFlow } from './analyticEvents';

/**
 * @method trackSessionRecoveryInitiate
 * @description this method tracks the session recovery initiation
 * @param {string} formName (form name) [name of the form]
 */
export const trackSessionRecoveryInitiate = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.INITIATED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackSessionRecoveryComplete
 * @description this method tracks the session recovery complete
 * @param {string} formName (form name) [name of the form]
 */
export const trackSessionRecoveryComplete = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.COMPLETED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackSessionRecoveryError
 * @description this method tracks the session recovery error
 * @param {string} formName (form name) [name of the form]
 */
export const trackSessionRecoveryError = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.ERROR,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackSessionRecoveryStartNew
 * @description this method tracks user selection for start-new question in session recovery
 * @param {string} formName (form name) [name of the form]
 * @param {string} answer (answer) [user's answer - "Yes" or "No"]
 */
export const trackSessionRecoveryStartNew = (
  formName: string,
  answer: string
) => {
  trackFormInput(
    formName,
    ANALYTICS.NUMBER_ONE,
    ANALYTICS.START_NEW_SESSION_FORM_QUESTION,
    answer,
    '1'
  );
};
